import React, { Component } from 'react'
import { connect } from 'react-redux'
import { toggleStepsList, toggleResponsesList, selectResponse, selectStep, selectMode, selectFeature } from '../actions/commonActions'

import '../styles/checkout/mainStyle.css'

import Configuration from '../components/checkout/steps/Configuration'
import Overview from '../components/checkout/steps/Overview'
import ClientSideCheckOut from '../components/checkout/steps/ClientSideCheckOut'
import PreloadRequest from '../components/checkout/steps/PreloadRequest'
import DisplayBrowser from '../components/checkout/steps/DisplayBrowser'
import HandleCallbacks from '../components/checkout/steps/HandleCallbacks'
import Receipt from '../components/checkout/steps/Receipt'
import Terminate from '../components/checkout/steps/Terminate'
import Testing from '../components/checkout/steps/Testing'
import Production from '../components/checkout/steps/Production'
import CheckoutPage from '../components/checkout/responses/CheckoutPage'
import PreloadPage from '../components/checkout/responses/PreloadPage'
import Receiptpage from '../components/checkout/responses/ReceiptPage'
import IframePage from '../components/checkout/responses/IframePage'

import Indicator from '../components/common/Indicator'
import StepsList from '../components/common/StepsList'
import StepsMenu from '../components/common/StepsMenu'
import ResponseList from '../components/common/ResponseList'
import { FEATURES } from '../constants/common/Features'
import responses from '../constants/checkout/responses'
// import Response from '../components/common/Response'
import { _MCO } from '../actions/types'
import Footer from '../components/common/Footer'


var isIE = /*@cc_on!@*/false || !!document.documentMode;
var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

const scrollToRef = (ref) => {ref.current.scrollIntoView({behavior: "smooth"})}

const steps = FEATURES.mco.steps;

export class MCOPage extends Component {
    state = {
        isExpanded: false,
        leftContainerRef:React.createRef(),
        overviewRef:React.createRef(),
        clientSideRef:React.createRef(),
        preloadRef:React.createRef(),
        displayRef:React.createRef(),
        receiptRef:React.createRef(),
        terminateRef:React.createRef(),
        callBackRef:React.createRef(),
        testingRef:React.createRef(),
        productionRef:React.createRef(),
    };

    componentDidMount() {
        if(this.props.mode === "integration_guide")
            this.scrollIntoStep(this.props.selectedStep);

        document.title = 'MCO | Moneris Developers';
    }

    componentDidUpdate(prevProps) {
        const { selectedStep, mode } = this.props;

        if(mode !== prevProps.mode && mode === 'integration_guide') {
            this.scrollIntoStep(selectedStep)
        }
    }
      
    isInViewport(elem) {
        if (!elem) return false;
        const offset = window.pageYOffset;
        const top = elem.getBoundingClientRect().top;
        return (top + offset) >= 0 && (top - offset) <= window.innerHeight;
    }

    justLeft(elem) {
        if (!elem) return false;
        const offset = window.pageYOffset;
        const top = elem.getBoundingClientRect().top;
        const diff = (top - offset) - window.innerHeight;
        return (top + offset) >= 0 && diff > 0 && diff < 100;
    }

    scrollIntoStep(stepId) {
        switch(stepId) {
            case 1:
                scrollToRef(this.state.overviewRef)
                break
            case 2:
                scrollToRef(this.state.clientSideRef)
                break
            case 3:
                scrollToRef(this.state.preloadRef)
                break
            case 4:
                scrollToRef(this.state.displayRef)
                break
            case 5:
                scrollToRef(this.state.receiptRef)
                break
            case 6:
                scrollToRef(this.state.terminateRef)
                break
            case 7:
                scrollToRef(this.state.callBackRef)
                break
            case 8:
                scrollToRef(this.state.testingRef)
                break
            case 9:
                scrollToRef(this.state.productionRef)
                break
            
            default:
                scrollToRef(this.state.overviewRef)
                break
        }
    }

    handleScrolling() {
        const { overviewRef, clientSideRef, preloadRef, displayRef, receiptRef,terminateRef,callBackRef,testingRef,productionRef} = this.state
        const { selectStep } = this.props

        if(this.isInViewport(overviewRef.current) || this.justLeft(clientSideRef.current)) {
            selectStep({stepId: 1, featureId: _MCO});
            return
        }
        if(this.isInViewport(clientSideRef.current) || this.justLeft(preloadRef.current)) {
            selectStep({stepId: 2, featureId: _MCO});
            return
        }
        if(this.isInViewport(preloadRef.current) || this.justLeft(displayRef.current)) {
            selectStep({stepId: 3, featureId: _MCO});
            return
        }
        if(this.isInViewport(displayRef.current) || this.justLeft(receiptRef.current)) {
            selectStep({stepId: 4, featureId: _MCO});
            return
        }
        if(this.isInViewport(receiptRef.current) || this.justLeft(terminateRef.current)) {
            selectStep({stepId: 5, featureId: _MCO});
            return
        }
        if(this.isInViewport(terminateRef.current) || this.justLeft(callBackRef.current)) {
            selectStep({stepId: 6, featureId: _MCO});
            return
        }
        if(this.isInViewport(callBackRef.current) || this.justLeft(testingRef.current)) {
            selectStep({stepId: 7, featureId: _MCO});
            return
        }
        if(this.isInViewport(testingRef.current) || this.justLeft(productionRef.current)) {
            selectStep({stepId: 8, featureId: _MCO});
            return
        }    
        if(this.isInViewport(productionRef.current)) {
            selectStep({stepId: 9, featureId: _MCO});
            return
        }
    }

    renderStepsContent() {
        if(this.props.mode === 'integration_guide') {
            return (
                <div className='pageContents'>
                    <div className='stepsContainer'>
                        <span ref={this.state.overviewRef}></span>
                        <Overview />
                        <span ref={this.state.clientSideRef}></span>
                        <ClientSideCheckOut/>
                        <span ref={this.state.preloadRef}></span>
                        <PreloadRequest  />
                        <span ref={this.state.displayRef}></span>
                        <DisplayBrowser/>
                        <span ref={this.state.receiptRef}></span>
                        <Receipt />
                        <span ref={this.state.terminateRef}></span>
                        <Terminate />  
                        <span ref={this.state.callBackRef}></span>
                        <HandleCallbacks />
                        <span ref={this.state.testingRef}></span>
                        <Testing />
                        <span ref={this.state.productionRef}></span>
                        <Production />
                    </div>
                    <Footer />
                </div>
            )
        }
        else {
            switch (this.props.selectedStep) {
                case 1:
                    return <Overview />
                case 2:
                    return <ClientSideCheckOut />
                case 3:
                    return <PreloadRequest />
                case 4:
                    return <DisplayBrowser />
                case 5:
                    return <Receipt />
                case 6:
                    return <Terminate />  
                case 7:
                    return <HandleCallbacks />
                case 8:
                    return <Testing />
                case 9:
                    return <Production />
                default:
                    return null
            }
        }
    }


    renderResponseContent() {
        switch (this.props.selectedResponse) {
            case 1:
                return <CheckoutPage />
            case 2:
                return <PreloadPage />
            case 3:
                return <Receiptpage />
            default:
                return null
        }
    }

    clickExpand() {
        this.setState({ isExpanded: !this.state.isExpanded})
        this.forceUpdate()
    }
    

    onNextPress() {
        const { selectStep, selectedStep } = this.props;
        var nextStep = (selectedStep + 1) % steps.length;
        if (nextStep === 0) nextStep = steps.length;
        selectStep({stepId: nextStep, featureId: _MCO});

    }

    onPrevPress() {
        const { selectStep, selectedStep } = this.props;
        var prevStep = (selectedStep - 1 + steps.length) % steps.length;
        if (prevStep === 0) prevStep = steps.length;
        selectStep({stepId: prevStep, featureId: _MCO});
    }


    scrollToTop = () => {    
        this.state.leftContainerRef.current.scrollIntoView()
    }


    // renderRightSide(){
    //     const { mode } = this.props;
    //     return(
    //         <div style={{ display: mode === 'interactive_tool'? 'flex' : 'none'}}>
    //             {(this.state.isExpanded) ? 
    //             <i onClick={() => this.clickExpand()} className={"material-icons scrollToLeft"}>{'keyboard_arrow_left'}</i> :
    //             <i onClick={() => this.clickExpand()} className={"material-icons scrollToLeft"}>{'keyboard_arrow_right'}</i>
    //             }
    //                 <div  className={this.state.isExpanded? "rightContainerExpand2": "rightContainer"}>
    //                     {this.props.selectedStep === 1 || this.props.selectedStep === 2 ||this.props.ifDisplayIframe ? null : null }
    //                     {this.props.selectedStep === 1 || this.props.selectedStep === 2 ||this.props.ifDisplayIframe ? null : <ResponseList expand={this.state.isExpanded} />}
    //                     {<IframePage />}
    //                     {this.renderResponseContent()}
    //                 </div>
    //         </div>

    //     )
    // }

    renderResponseList() {
        const { selectResponse, toggleResponsesList, isResponsesListOpen, selectedResponse, ifDisplayIframe } = this.props;

        if(!ifDisplayIframe) {
            return (
                <ResponseList
                    isOpen={isResponsesListOpen}
                    selection={selectedResponse}
                    // responses={responses.filter((response) => this.props.history.includes(response.id))}
                    responses={responses}
                    toggleResponseList={toggleResponsesList}
                    selectResponse={selectResponse}
                    featureId={_MCO}
                />
            )
        }
    }

    renderRightSide() {
        const { mode } = this.props;

        if(mode === 'interactive_tool') {
            return (
                    <div className="rightContainer" style={{flex: 4}}>
                        {this.renderResponseList()}

                        <div className="rightContents" style={{paddingLeft: '3%'}}>
                            {this.renderResponseContent()}
                            <IframePage />
                            {/* {this.renderNextSteps()} */}
                        </div>
                    </div>
            );
        }
    }

    renderLeftSide() {
        const { selectedStep, selectStep, toggleStepsList, isStepsListOpen, mode } = this.props;

        if(mode === 'interactive_tool') {
            return (
                <div className='leftContainer' style={{flex: 3}}>
                    <StepsList 
                        isOpen={isStepsListOpen}
                        selection={selectedStep} 
                        toggleStepsList={toggleStepsList} 
                        steps={steps.filter((step) => [3, 4, 5, 6].includes(step.id))} //only interactive steps
                        selectStep={selectStep}
                        featureId={_MCO}
                    />
                    {this.renderStepsContent()}
                </div>
            );
        }
        else {
            return (
                <div className="documentContainer" onWheel={() => this.handleScrolling()}>
                    <StepsMenu 
                        selectStep={selectStep}
                        selection={selectedStep}
                        steps={steps}
                        featureId={_MCO}
                        scrollIntoStep={(stepId) => this.scrollIntoStep(stepId)}
                    />
                    {this.renderStepsContent()}
                </div>
            );
        }
    }

    renderUpArrow() {
        if(this.props.mode === 'integration_guide') {
            if(isIE) {
                return (
                    <div style={{ marginLeft: '42vw', marginTop: '55vh'}} className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                        <span style={{ marginTop: '1vh' }}>&#8679;</span>
                    </div>
                );
            }
            else if(isSafari) {
                return (
                    <div style={{ marginLeft: '45vw', marginTop: '30vh', paddingBottom: '1vh'}} className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                        <span style={{ marginTop: '1vh' }}>&#8679;</span>
                    </div>
                );
            }
            else {
                if(navigator.platform === "Win32") {
                    return (
                        <div className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                            <span>&#129093;</span>
                        </div>
                    );
                }
                else {
                    return (
                        <div className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                            <span>&#8679;</span>
                        </div>
                    );
                }
            }
        }
    }    


    render() {
        const { selectedStep, selectStep } = this.props;

        return (
            <div className="desktop">
                <Indicator 
                    title="Moneris Checkout (MCO)"
                    steps={FEATURES.mco.steps}
                    renderConfig={() => <Configuration />}
                    selection={selectedStep}
                    selectStep={selectStep}
                    isInteractive={() => [3, 4, 5, 6].includes(selectedStep)}
                    history={[]}
                />
                
                <div className="mainContainer">
                    {this.renderLeftSide()}
                    {this.renderRightSide()}
                    {this.renderUpArrow()}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const selectedStep = state.checkout.stepsList.selection;
    const isStepsListOpen = state.checkout.stepsList.isOpen;
    const selectedResponse = state.checkout.responseList.selection;
    const isResponsesListOpen = state.checkout.responseList.isOpen;
    const { mode } = state.common.sideNav;
    const {ifDisplayIframe} = state.checkout.main;
    return { selectedStep, isStepsListOpen, selectedResponse, isResponsesListOpen, ifDisplayIframe, mode };
}

export default connect(mapStateToProps, { toggleStepsList, toggleResponsesList, selectResponse, selectStep, selectMode, selectFeature })(MCOPage);
